(function () {
  var bar = document.querySelector(".scroll-indicator");
  var fill = document.getElementById("scroll-indicator-fill");
  var toggleSpacer = document.getElementById("scroll-indicator-toggle-spacer");
  var spacer = document.getElementById("scroll-indicator-spacer");
  var status = document.getElementById("scroll-indicator-status");
  var rafId = 0;

  if (!fill) {
    return;
  }

  function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function getPageHeight() {
    var doc = document.documentElement;
    var body = document.body;

    return Math.ceil(
      Math.max(
        body ? body.scrollHeight : 0,
        body ? body.offsetHeight : 0,
        doc ? doc.clientHeight : 0,
        doc ? doc.scrollHeight : 0,
        doc ? doc.offsetHeight : 0
      )
    );
  }

  function update() {
    var top = getScrollTop();
    var viewportHeight = Math.floor(window.innerHeight || document.documentElement.clientHeight || 1);
    var pageHeight = getPageHeight();
    var scrollableHeight = pageHeight - viewportHeight;

    // Treat tiny differences as non-scrollable to avoid intermittent 0% on equal-height pages.
    var percent = scrollableHeight <= 1 ? 100 : Math.min(Math.max((top / scrollableHeight) * 100, 0), 100);
    var percentInt = percent.toFixed(0);
    var formattedPercent = percentInt.length < 3 ? "&nbsp;" + percentInt : percentInt;

    fill.style.width = percent.toFixed(2) + "%";

    if (bar) {
      bar.setAttribute("aria-valuenow", percent.toFixed(0));
    }

    if (status) {
      var spacerState = toggleSpacer && toggleSpacer.checked ? "enabled" : "disabled";
      status.innerHTML =
        "<strong>Status:</strong> Spacer " +
        spacerState +
        ". Progress <span class=\"font--monotype\">" +
        formattedPercent +
        "%</span>.";
    }
  }

  function scheduleUpdate() {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(update);
  }

  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("resize", scheduleUpdate);
  window.addEventListener("load", scheduleUpdate);
  document.addEventListener("DOMContentLoaded", scheduleUpdate);
  document.addEventListener("refreshFrame", scheduleUpdate);
  document.addEventListener("refreshStickyLayout", scheduleUpdate);

  if (toggleSpacer && spacer) {
    spacer.hidden = !toggleSpacer.checked;
    toggleSpacer.addEventListener("change", function () {
      spacer.hidden = !toggleSpacer.checked;
      document.dispatchEvent(new CustomEvent("refreshFrame"));
      scheduleUpdate();
    });
  }

  scheduleUpdate();
})();
